import ReactD3MultiSeriesChart from "../../../../AxiomComponents/AxiomUI/ReactD3MultiSeriesChart/ReactD3MultiSeriesChart";

function negativeGrowthChartComponent(
  componentName,
  availableHeight,
  availableWidth,
  data,
  appName,
  appID,
  field,
  value,
  pointInfo
) {
  const totalPoints = data.filter((d) => {
    return isFinite(d.Growth) && d.Growth != null && d.Growth != "";
  }).length;

  const negativePoints = data.filter((d) => {
    const growth = isFinite(d.Growth) ? d.Growth * 100 : 0;
    return growth < 0;
  }).length;
  const title = [
    { text: `${negativePoints} out of ${totalPoints}`, class: "highlight" },
    { text: `months are having negative growth for ${field}` },
    { text: value, class: "highlight" },
  ];
  const chartData = {
    id: AxiomAPIs.generateUUID(16, "aA"),
    config: {
      width: availableWidth,
      height: availableHeight,
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      data: data,
      margins: {
        top: 10,
        right: 50,
        bottom: 30,
        left: 60,
      },
      xAxis: [
        {
          categories: data.map((d) => d.Month),
          orient: "bottom",
          crosshair: false,
          lineColor: "#808080",
          lineWidth: 0.5,
          tickColor: "#808080",
          tickLineRequired: true,
          tickWidth: 0.5,
          labels: {
            style: {
              color: "white",
              fontSize: "14px",
            },
            format: "",
            prefix: "",
            postfix: "",
          },
          gridLineWidth: 1,
        },
      ],
      yAxis: [
        {
          orient: "left",
          title: {
            text: "",
            style: {
              color: "white",
            },
          },
          zeroBase: false,
          crosshair: false,
          lineColor: "#808080",
          lineWidth: 0.01,
          tickColor: "#808080",
          tickLineRequired: false,
          ticks: 5,
          tickWidth: 0.5,
          stackLabels: {},
          labels: {
            style: {
              color: "white",
              fontSize: "14px",
            },
            format: "0.[0]",
            prefix: "",
            postfix: "%",
          },
        },
      ],
      series: [
        {
          type: "column",
          yAxis: 0,
          name: "% Change",
          // fillColor: "#9AAD86", //
          data: data.map((d) => {
            const growth = isFinite(d.Growth) ? d.Growth * 100 : 0;
            return {
              fillColor: growth < 0 ? "rgb(216, 125, 103)" : "rgba(74, 164, 184)",
              data: growth,
            };
          }),
          dataLabels: {
            enabled: false,
            style: {
              fill: "white",
              fontSize: "12px",
            },
          },
          marker: {},
          tooltip: true,
          tooltipPosition: "cursor",
          tooltipStyle: {
            valuePrefix: "",
            labelFontSize: "12px",
            labelFontColor: "#808080",
            labelFontFamily: "",
            valueFontSize: "12px",
            valueFontColor: "#808080",
            valueFontFamily: "",
            valuePostfix: "",
          },
          hoverStyle: {
            labelStyle: {
              fontSize: "14px",
              fontWeight: "bold",
              color: "green",
            },
            barStyle: {
              fill: "#4AA4B8",
            },
          },
        },
      ],
      legend: [],
    },
  };
  const component = (
    <ReactD3MultiSeriesChart {...chartData} appName={appName} appID={appID} componentID="0" />
  );
  return { title, component };
}

module.exports = negativeGrowthChartComponent;
